import { useEffect, useState } from "react";
import api from "../lib/api";
import DataTable from "../components/DataTable";
import PageHeader from "../components/PageHeader";
import { Badge, statusVariant } from "../components/Badge";
import { fmtBDT, fmtDateTime } from "../lib/format";
import { ArrowDownToLine, ArrowUpFromLine, Target } from "lucide-react";

const filters = [
  { key: "", label: "All Types" },
  { key: "deposit", label: "Deposits" },
  { key: "withdraw", label: "Withdrawals" },
  { key: "bet", label: "Bets" },
];

export default function Transactions() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      const params = type ? { tx_type: type } : {};
      const { data } = await api.get("/transactions", { params });
      setRows(data);
      setLoading(false);
    })();
  }, [type]);

  const typeBadge = (t) => {
    if (t === "deposit") return <span className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-sm"><ArrowDownToLine size={10} /> Deposit</span>;
    if (t === "withdraw") return <span className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 bg-red-50 text-red-700 border border-red-200 rounded-sm"><ArrowUpFromLine size={10} /> Withdraw</span>;
    return <span className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 bg-amber-50 text-amber-700 border border-amber-200 rounded-sm"><Target size={10} /> Bet</span>;
  };

  return (
    <div data-testid="transactions-page">
      <PageHeader title="All Transactions" subtitle="Unified log of deposits, withdrawals and bets" />
      <div className="flex items-center gap-2 mb-4" data-testid="tx-filters">
        {filters.map((f) => (
          <button
            key={f.key}
            onClick={() => setType(f.key)}
            data-testid={`tx-filter-${f.key || "all"}`}
            className={`h-9 px-4 text-sm rounded-sm border transition-colors ${type === f.key ? "bg-[#09090B] text-white border-[#09090B]" : "bg-white text-gray-700 border-gray-200 hover:border-gray-400"}`}
          >
            {f.label}
          </button>
        ))}
      </div>
      <DataTable
        testId="transactions-table"
        loading={loading}
        rows={rows}
        columns={[
          { key: "type", label: "Type", render: (r) => typeBadge(r.type) },
          { key: "txn_id", label: "Reference", render: (r) => <span className="font-mono text-xs">{r.txn_id || `BET-${r.id?.slice(0, 6)}`}</span> },
          { key: "player_name", label: "Player" },
          { key: "player_user_id", label: "UserId" },
          { key: "amount", label: "Amount", align: "right", render: (r) => fmtBDT(r.amount) },
          { key: "status", label: "Status", render: (r) => <Badge variant={statusVariant(r.status)}>{r.status}</Badge> },
          { key: "created_at", label: "Date", render: (r) => fmtDateTime(r.created_at) },
        ]}
      />
    </div>
  );
}
